var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.qr))]),(!_vm.waiting)?_c('button',{on:{"click":_vm.initQRcode}},[_vm._v("Start")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }